/**
 * WelcomeScreen
 *
 * Entry point when there's no local session. Registrazione INVITE-ONLY:
 * da qui non si crea un'identità senza invito (lo si fa aprendo un link
 * /i/<token>). Percorsi disponibili:
 *   - su invito → apri il link di invito ricevuto
 *   - ho già un account (Door B: sigil + PIN)
 *   - ho perso il PIN (Door C: 24 parole)
 */

import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Frame, Footer, Btn, Cursor } from '../components/Frame';
import { isNativeApp } from '../lib/platform';

export default function WelcomeScreen() {
  const navigate = useNavigate();
  const [code, setCode] = useState('');

  // Accetta sia il codice nudo sia un eventuale link incollato (estrae il token
  // dopo /i/). Poi entra nel flusso invito standard /i/<token>.
  function enterWithCode() {
    const c = code.trim().replace(/^.*\/i\//, '').replace(/[^A-Za-z0-9_-]/g, '');
    if (c) navigate(`/i/${c}`);
  }

  return (
    <Frame statusLeft="SECURE_LINK" statusRight="●●●●  5G">
      <div className="flex flex-col items-center text-center pt-3">
        <div className="text-ink text-glow text-[44px] font-bold tracking-[0.22em] leading-none">
          NULLUM
        </div>
        <div className="text-ink-dim text-[13px] tracking-[0.28em] uppercase mt-3">
          messaggi anonimi · cifrati
        </div>
        <div className="text-ink/70 text-[14px] mt-2">
          &gt; sistema pronto<Cursor />
        </div>
      </div>

      <Footer>
        <p className="text-[14px] text-ink-dim mb-2">come vuoi entrare?</p>
        <div className="border border-ink-dim/50 rounded-xl bg-ink/[0.015] p-3 text-[13px] text-ink-dim text-left mb-3 leading-relaxed">
          🔒 Per ora si entra solo <b className="text-ink text-glow">su invito</b>. Apri il
          <b className="text-ink"> link di invito</b> che hai ricevuto per creare la tua identità.
          <div className="mt-3 pt-3 border-t border-ink-dim/30">
            <p className="text-[12px] mb-1.5">Hai solo un <b className="text-ink">codice</b>? Incollalo qui:</p>
            <div className="flex gap-2">
              <input
                value={code}
                onChange={(e) => setCode(e.target.value)}
                onKeyDown={(e) => { if (e.key === 'Enter') enterWithCode(); }}
                placeholder="codice invito"
                spellCheck="false"
                autoCapitalize="none"
                autoComplete="off"
                className="flex-1 min-w-0 bg-black border border-ink-dim text-ink font-mono text-[14px] px-2.5 py-1.5 rounded-lg focus:border-ink focus:outline-none"
              />
              <button
                onClick={enterWithCode}
                disabled={!code.trim()}
                className="shrink-0 border border-ink rounded-lg bg-ink/10 text-ink text-glow text-[13px] px-3 py-1.5 hover:bg-ink/20 transition-colors disabled:opacity-40"
              >
                Entra ▶
              </button>
            </div>
          </div>
        </div>
        <Btn onClick={() => navigate('/restore')}>
          ↺ Ho già un account
        </Btn>
        <Btn variant="ghost" onClick={() => navigate('/recover')}>
          Ho perso il PIN — uso le 24 parole
        </Btn>
        {!isNativeApp() && (
          <Btn variant="ghost" onClick={() => navigate('/install')}>
            📲 Come installare sul telefono
          </Btn>
        )}
        <p className="text-center text-[13px] text-ink-dim tracking-wide pt-3">
          nessun nome · nessun volto
        </p>
      </Footer>
    </Frame>
  );
}
